<style lang="scss" scoped>
@use '~@/styles/main';
@use '~@/styles/base/variables';

.list-item {
  display: inline-block;
  margin-right: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 0.3s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(60px);
}

.text-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
}

.expired-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .text {
    font-size: 24px;
  }
}

.error-text {
  font-size: 24px;
}

.main {
  --header-height: 70px;
  --main-p: 10px;
  --main-gap: 7px;

  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: var(--main-gap);
  min-width: 540px;
  padding: var(--main-p);
  padding-bottom: 0;
  overflow: hidden;
}

.header {
  $px: 20px;

  position: relative;
  height: var(--header-height);
  border-radius: 6px;
  background-color: var(--color-card);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
  padding: 0 $px;

  &__logo {
    display: flex;
    position: absolute;
    left: $px;
  }

  &__select {
    text-align: left;
    width: 145px;

    &_error {
      ::v-deep .ivu-select-selection {
        border-color: var(--color-danger-light);
      }
    }
  }
}

.chart-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  overflow: hidden;
}

.mobile-section {
  --section-row-gap: 10px;

  flex: 1 1 auto;
  display: grid;
  grid-row-gap: var(--section-row-gap);
  grid-column-gap: 20px;
  padding-bottom: 20px;

  $section-height: calc(
    100vh - var(--header-height) - var(--section-row-gap) - var(--main-gap) - 2 *
      var(--main-p)
  );

  ::v-deep .chart-wrapper {
    min-height: calc(#{$section-height} / 2);

    @media screen and (max-height: 760px) {
      min-height: $section-height;
    }
  }
}

@media screen and (max-width: variables.$small) {
  .header__add-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 60px;
    height: 100%;
  }
}

// Target All touch screen and mobile devices
@media only screen and (hover: none) and (pointer: coarse) {
  .main {
    --header-height: 56px;
  }

  .mobile-section {
    --section-row-gap: 30px;
  }

  @media (orientation: landscape) {
    .main {
      --header-height: 48px;
    }

    .mobile-section {
      padding-right: 20px;
      --section-row-gap: 10px;
    }
  }
}
</style>

<template>
  <div class="main">
    <div
      v-if="loading"
      class="text-wrapper"
    >
      <LoadingIndicator />
    </div>
    <div
      v-else-if="isExpired"
      class="text-wrapper"
    >
      <span
        v-if="payRequestError"
        class="error-text"
      >
        {{payRequestError}}
      </span>
      <div
        v-else
        class="expired-wrapper"
      >
        <span class="text">{{$text.tr('Сервис доступен по подписке')}}</span>
        <!--        <Button-->
        <!--          @click="$router.push('/pay')"-->
        <!--          size="large"-->
        <!--          type="primary"-->
        <!--        >{{-->
        <!--        $text.tr('ОПЛАТА')-->
        <!--      }}</Button>-->
      </div>
    </div>
    <template v-else>
      <header
        id="header"
        class="header"
      >
        <router-link
          class="header__logo"
          target="_blank"
          to="/terminal"
        >
          <img
            src="data:image/png;base64,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"
            width="24"
            height="24"
          >
        </router-link>
        <Select
          id="exchange"
          class="header__select"
          v-model="exchangeKey"
          placeholder="биржа"
        >
          <Option
            v-for="(value, key) in exchanges"
            :key="key"
            :value="key"
          >{{ value }}</Option>
        </Select>
        <SymbolsChooser
          v-model="symbol"
          :error.sync="symbolsChooserError"
          :symbols="allSymbols[exchangeKey]"
          selectStyle
          noFav
        />
        <button
          class="ghost-btn ghost-btn_success header__add-btn"
          :disabled="isAddButtonDisabled"
          @click="addChart()"
          :title="$text.tr('Добавить график')"
        >
          <Icon
            type="md-add"
            size="18"
          />
        </button>
      </header>
      <div
        v-if="isMobile"
        class="mobile-section"
      >
        <div
          v-for="(item, index) in mobileCharts"
          :key="item.id"
          class="chart-wrapper"
        >
          <ChartHeader
            :chart="item"
            :symbols="allSymbols[item.exchangeKey]"
            @delete="deleteChart(index)"
          />
          <Chart
            class="chart"
            :chart="item"
          />
        </div>
      </div>
      <Dashboard
        v-else
        :dashboard.sync="dashboard"
        :currentLayout.sync="currentLayout"
        defaultKey="defaultScreenerDashboardJSON"
        :localStorageKey="dashboardKey"
        noDelete
      >
        <template v-slot:item="{ item, index }">
          <div class="chart-wrapper">
            <ChartHeader
              :chart="item"
              :symbols="allSymbols[item.exchangeKey]"
              @delete="deleteChart(index)"
            />
            <Chart
              class="chart"
              :chart="item"
            />
          </div>
        </template>
      </Dashboard>
    </template>
  </div>
</template>

<script>
import Api from '@/util/api'
import Util from '@/util/util'
import Dashboard from '@/components/common/Dashboard'
import ChartHeader from '@/components/Screener/ChartHeader'
import SymbolsChooser from '@/components/common/SymbolsChooser'
import LoadingIndicator from '@/components/common/LoadingIndicator'
import Chart from './Chart'
import PayApi from '@/util/payapi'
import Constants from '@/util/constants'

export default {
  components: {
    Dashboard,
    ChartHeader,
    SymbolsChooser,
    LoadingIndicator,
    Chart
  },
  data () {
    return {
      symbolsChooserError: false,
      maxChartAmount: 8,
      symbol: 'BTC/USDT',
      exchangeKey: 'BIN',
      exchanges: {
        BIN: 'Binance',
        BIF: 'Futures',
        HUO: 'HTX',
        // EXM: 'Exmo',
        // FTX: 'FTX',
        OKX: 'OKX'
      },
      mobileCharts: [
        {
          symbol: 'BTC/USDT',
          exchange: 'Binance',
          exchangeKey: 'BIN',
          id: 'tv_chart_container_1_1',
          lastPrice: ''
        },
        {
          symbol: 'ETH/USDT',
          exchange: 'Binance',
          exchangeKey: 'BIN',
          id: 'tv_chart_container_2_2',
          lastPrice: ''
        }
      ],
      allSymbols: {
        BIN: [],
        BIF: [],
        HUO: [],
        EXM: [],
        FTX: [],
        OKX: []
      },
      dashboard: [],
      currentLayout: {},
      dashboardKey: 'screener_dashboard_charts',
      mobileChartsKey: 'screener_mobile_charts',
      isExpired: false,
      loading: false,
      payRequestError: ''
    }
  },
  watch: {
    symbolsChooserError: function (value) {
      if (value) {
        this.setDefaultSymbol()
      }
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.sys.breakpoint === 'small'
    },
    isLarge () {
      return this.$store.state.sys.breakpoint === 'xl'
    },
    exchangeName () {
      return this.exchanges[this.exchangeKey]
    },
    isMaxChartAmountExceeded () {
      if (this.isMobile) {
        return this.mobileCharts.length >= this.maxChartAmount
      } else {
        return (
          this.currentLayout &&
          this.currentLayout.items &&
          this.currentLayout.items.length >= this.maxChartAmount
        )
      }
    },
    isAddButtonDisabled () {
      return (
        !this.symbol ||
        !this.symbol.trim() ||
        this.isMaxChartAmountExceeded ||
        this.symbolsChooserError
      )
    }
  },
  beforeCreate () {
    window.name = 'MultiChart ｜ Capico'
    document.title = 'MultiChart ｜ Capico'
  },
  created () {
    // this.checkSubscription()
    this.setSavedEmail()
    localStorage.setItem('screener-opened', Date.now())
    window.addEventListener('storage', this.preventDuplicateTab, false)

    this.setMobileCharts()
    this.getAllSymbols()
    setInterval(() => {
      this.getAllSymbols()
    }, 60 * 1000)
  },
  mounted () {
    if (!localStorage.getItem(this.dashboardKey)) {
      this.setDefaultDashboard()
    }
  },
  methods: {
    setSavedEmail () {
      if (!this.$store.state.sys.email) {
        this.$store.state.sys.email = localStorage.getItem('email')
      }
    },
    async checkSubscription () {
      await PayApi.get('info', {
        params: {
          token: this.$store.state.sys.token
        }
      })
        .then(response => {
          if (!response.data.err) {
            if (response.data.Active === true) {
              this.isExpired = false
            }
          } else {
            this.applySubscriptionError(response.data.err)
          }
        })
        .catch(error => {
          this.applySubscriptionError(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    setDefaultSymbol () {
      switch (this.exchangeKey) {
        case 'BIN':
        case 'BIF':
        case 'HUO':
        case 'OKX':
          this.symbol = 'BTC/USDT'
          break
        case 'EXM':
        case 'FTX':
          this.symbol = 'BTC/USD'
          break
      }
    },
    applySubscriptionError (error) {
      this.payRequestError = error
      this.$Notice.error({
        title: this.$text.tr('Ошибка'),
        desc: Util.returnTextForErr(error),
        duration: 10
      })
    },
    preventDuplicateTab (e) {
      if (e.key === 'screener-opened') {
        localStorage.setItem('screener-available', Date.now())
      }

      if (
        e.key === 'screener-available' &&
        window.opener &&
        window.opener.name !== 'screener'
      ) {
        window.close()
        window.open(`${window.location.origin}/app/multichart`, 'screener')
      }
    },
    async getAllSymbols () {
      for (const key in this.exchanges) {
        await this.getSymbolsByKey(key)
      }
      this.$store.state.data.allSymbols = this.allSymbols
    },
    getSymbolsByKey (key) {
      Api.get(
        'exch/symbols?token=' + this.$store.state.sys.token + '&eid=' + key
      )
        .then(response => {
          this.allSymbols[key].length = 0
          this.allSymbols[key] = response.data.Symbols
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    setMobileCharts () {
      const mobileChartsJSON = localStorage.getItem(this.mobileChartsKey)

      if (mobileChartsJSON) {
        this.mobileCharts = JSON.parse(mobileChartsJSON)
      }
    },
    setDefaultDashboard () {
      this.dashboard.forEach(layout => {
        this.addDashboardChart(layout, 'BTC/USDT')
        this.addDashboardChart(layout, 'ETH/USDT')
      })
    },
    addChart () {
      if (this.isAddButtonDisabled) {
        return
      }

      if (this.isMobile) {
        this.addMobileChart()
        this.saveMobileCharts()
      } else {
        this.addDashboardChart()
        this.saveDashboard()
      }

      setTimeout(() => {
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
          behavior: 'smooth'
        })
      }, 300)
    },
    addMobileChart () {
      const chart = {
        symbol: this.symbol,
        exchange: this.exchangeName,
        exchangeKey: this.exchangeKey,
        id: this.getRandomChartId(),
        lastPrice: ''
      }

      this.mobileCharts.push(chart)
    },
    addDashboardChart (layout = this.currentLayout, symbol = this.symbol) {
      const gap = layout.breakpoint === 'xl' ? 5 : 3
      const header = document.getElementById('header')
      let height = Math.floor(
        (document.body.clientHeight - header.offsetHeight) / (gap * 10)
      )
      const length = layout.items.length
      const halfWidth = layout.numberOfCols / 2

      if (height < 10) {
        height = 10
      }

      const item = {
        id: this.getRandomChartId(),
        name: 'ГРАФИК',
        x: (length % 2) * halfWidth,
        y: this.getBiggestItemHeight(layout),
        width: halfWidth,
        height: height < 10 ? 10 : height,
        minHeight: 10,
        symbol,
        exchangeKey: this.exchangeKey,
        exchange: this.exchangeName,
        lastPrice: '',
        resizeEdges: 'left right bottom',
        locked: false
      }

      layout.items.push(item)
    },
    getRandomChartId () {
      return `tv_chart_container_${Date.now()}_${Math.random()}`
    },
    getBiggestItemHeight (layout = this.currentLayout) {
      let maxHeight = 0

      layout.items.forEach(currentItem => {
        const totalCurrentHeight = currentItem.y + currentItem.height

        if (totalCurrentHeight > maxHeight) {
          maxHeight = totalCurrentHeight
        }
      })

      return maxHeight
    },
    deleteChart (index) {
      if (this.isMobile) {
        this.deleteMobileChart(index)
      } else {
        this.deleteDashboardChart(index)
      }
    },
    deleteMobileChart (index) {
      this.mobileCharts.splice(index, 1)
      this.saveMobileCharts()
    },
    deleteDashboardChart (index) {
      this.currentLayout.items.splice(index, 1)
      this.saveDashboard()
    },
    saveMobileCharts () {
      this.$nextTick(() => {
        localStorage.setItem(
          this.mobileChartsKey,
          JSON.stringify(this.mobileCharts)
        )
      })
    },
    saveDashboard () {
      localStorage.setItem(this.dashboardKey, JSON.stringify(this.dashboard))
    }
  }
}
</script>
